module.exports = __webpack_public_path__ + "static/img/icon13.9e56e7cf.png";